<script>
import Layout from '@layouts/main.vue'
import texts from '../../assets/data/localisations.json'

export default {
  page: {
    title: 'Topic',
    meta: [{ name: 'description', content: 'The Topic page.' }],
  },
  components: { Layout },
  data() {
    return {
      texts: null,
    }
  },
  computed: {
    categoryTopics() {
      return this.$store.getters['topics/categoryTopics']
    },
    allTopics() {
      return this.$store.getters['topics/filteredTopics']
    },
    hasTopics() {
      return this.$store.getters['topics/hasTopics']
    },
    locale() {
      return this.$store.getters['globals/locale']
    },
    params() {
      return this.$store.getters['globals/params']
    },
    platform() {
      return this.$store.getters['globals/platform']
    },
    isOldApp() {
      return this.$store.getters['globals/oldApp']
    },
    hyperdotApp() {
      return this.$store.getters['globals/hyperdotApp']
    },
    sa2App() {
      return this.$store.getters['globals/sa2App']
    },
    isContactTopicShown() {
      if (this.params.minimalRequest !== 'true' && !this.sa2App) return true
      return false
    },
  },
  created() {
    this.texts = texts
  },
  methods: {
    contactUrl() {
      if (this.isOldApp) {
        location.replace('https://outfit7.com/game-support/#contact-anchor')
      } else {
        this.$router.push({ name: 'contact' })
      }
    },
    isAndroid() {
      if (this.platform !== undefined)
        if (this.platform.includes('Android')) return true
      if (/Android/i.test(navigator.userAgent)) return true
      return false
    },
    dispatchMessage(message, ug, isLocal) {
      // messages that are 'pushed' were sent to support, but we don't have the confirmation yet that they were received.
      // pushed messages are only stored in the display queue and will be overwritten when we receive a new conversation list from the server
      // non-pushed messages are local messages which are not sent to server and are stored only for this session. These messages will be displayed throughout the session.
      this.$store.dispatch('topics/postLocalMessage', {
        body: message,
        userGenerated: ug,
        local: isLocal,
      })
      if (ug) {
        this.$store.dispatch('topics/postMessage', {
          description: message,
        })
      }
    },
    isCategoryTopicExpanded(topic) {
      if (this.$store.getters['topics/expandedCategoryTopics'].has(topic)) return true
      else return false
    },
    dispatchCategoryTopicExpand(topic) {
      this.$store.dispatch('topics/updateExpandedCategoryTopics', topic)
    },
  },
}
</script>

<template>
  <Layout>
    <div v-if="allTopics.length > 0">
      <md-list>
        <md-list-item
          v-for="(item, index) in categoryTopics"
          v-if="Object.keys(categoryTopics).length > 1"
          :key="index"
          md-expand
          :md-expanded="isCategoryTopicExpanded(index)"
          :to="'/topic/' + item.id"
          @click="dispatchCategoryTopicExpand(index)"
        >
          <span class="topic-title">{{ index }} {{ item.title }}</span>
          <md-list slot="md-expand">
            <md-list-item
              v-for="(i, j) in item"
              :key="j"
              class="md-inset"
              :to="'/topic/' + i.id"
              @click.stop
            >
              <span class="topic-title">{{ i.title }}</span>
            </md-list-item>
          </md-list>
        </md-list-item>
        <md-list-item
          v-for="(item, index) in allTopics"
          v-else
          :key="index"
          :to="'/topic/' + item.id"
        >
          <span class="topic-title">{{ item.title }}</span>
        </md-list-item>
        <md-list-item v-if="isContactTopicShown" @click="contactUrl" @touch="contactUrl">
          <span class="topic-title">{{ texts[locale].didntfind }}</span>
        </md-list-item>
      </md-list>
      <div v-if="isAndroid()" class="android-toolbarfix"></div>
    </div>
    <div v-else-if="hasTopics" class="no-results">
      {{ texts[locale].noresults }}
    </div>
  </Layout>
</template>

<style lang="scss">
.topic-title {
  white-space: normal;
  line-height: 22px;
}

.android-toolbarfix {
  height: 50px;
  width: 100%;
}

.no-results {
  padding: 20px;
  text-align: center;
}

.md-list-item.md-inset .md-list-item-content {
  padding-left: 56px;
}
</style>
